import { StyledBreadcrumbs } from '@/components/styles'
import JsonLd from '@/components/JsonLd'
import resolveBreadcrumbLink from '@/lib/resolveBreadcrumbLink'
import { buildBreadcrumbList } from '@/lib/schema'
import { useHost } from '@/contexts/HostContext'
import Link from 'next/link'

export default function Breadcrumbs({ items = [], theme, emitSchema = true }) {
  const host = useHost()
  const breadcrumbSchema = emitSchema
    ? buildBreadcrumbList(items, { host })
    : null

  return (
    <>
      <JsonLd data={breadcrumbSchema} />
      <StyledBreadcrumbs theme={theme}>
        {items.map((item, ind) => {
          const { id, title } = item
          const { href, as } = resolveBreadcrumbLink(item)

          return (
            <StyledBreadcrumbs.Item key={id}>
              {ind < items.length - 1 ? (
                <Link href={href} as={as} shallow={false} passHref>
                  <StyledBreadcrumbs.Link>{title}</StyledBreadcrumbs.Link>
                </Link>
              ) : (
                <span>
                  <StyledBreadcrumbs.Link as="span">{title}</StyledBreadcrumbs.Link>
                </span>
              )}
            </StyledBreadcrumbs.Item>
          )
        })}
      </StyledBreadcrumbs>
    </>
  )
}
